<div class="pt-2">
  <div class="fw-normal">
    {{ 'page.payroll.legende' | translate }}
  </div>
  <div class="d-flex">
    <fa-icon class="fw-normal" [icon]="faExchange"></fa-icon>
    <div class="px-2">
      {{ 'popup.find_staff.description' | translate }}
    </div>
  </div>
</div>
